import styled from 'astroturf';
import BaseCard from 'react-bootstrap/Card';
import Heading from './Heading';
import { useTheme } from './ThemeContext';
/** @component */

const Card = /*#__PURE__*/styled(BaseCard, null, {
  displayName: "Card",
  styles: require("./Card.module.scss"),
  attrs: props => ({ ...props,
    theme: useTheme()
  }),
  vars: []
});
/** @component */

const Header = /*#__PURE__*/styled(BaseCard.Header, null, {
  displayName: "Header",
  styles: require("./Card-Header.module.scss"),
  attrs: props => ({ ...props,
    as: Heading
  }),
  vars: []
});
const Body = /*#__PURE__*/styled(BaseCard.Body, null, {
  displayName: "Body",
  styles: require("./Card-Body.module.scss"),
  attrs: null,
  vars: []
});
/**
 * @deprecated add text directly under Card.Header
 */

const Title = /*#__PURE__*/styled(BaseCard.Title, null, {
  displayName: "Title",
  styles: require("./Card-Title.module.scss"),
  attrs: null,
  vars: []
});
const Footer = /*#__PURE__*/styled(BaseCard.Footer, null, {
  displayName: "Footer",
  styles: require("./Card-Footer.module.scss"),
  attrs: props => ({ ...props,
    theme: useTheme()
  }),
  vars: []
});
export default Object.assign(Card, {
  Header,
  Footer,
  Body,
  Title,
  Text: BaseCard.Text,
  Subtitle: BaseCard.Subtitle,
  Img: BaseCard.Img,
  ImgOverlay: BaseCard.ImgOverlay
});